<template>
  <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3933 6.24273C16.6645 5.97155 16.6645 5.53187 16.3933 5.26068L11.9741 0.84144C11.7029 0.570253 11.2632 0.570253 10.992 0.84144C10.7208 1.11263 10.7208 1.55231 10.992 1.82349L14.9202 5.75171L10.992 9.67992C10.7208 9.95111 10.7208 10.3908 10.992 10.662C11.2632 10.9332 11.7029 10.9332 11.9741 10.662L16.3933 6.24273ZM0.0299073 6.44613L15.9023 6.44612L15.9023 5.05729L0.0299072 5.05729L0.0299073 6.44613Z"
      fill="white" />
  </svg>
</template>